export function getUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw)?.user ?? null;
  } catch {
    return null;
  }
}

/**
 * Dead-session exit shared by the axios 401/403 interceptor and any component
 * that discovers the session is gone at save time. Stashes the current
 * location under `pendingDeepLink` (the login flow already resumes it after
 * sign-in) and sets a one-shot `sessionExpired` flag the login page reads to
 * explain the redirect, then clears the session and hard-redirects.
 */
export function expireSession() {
  const onAuthPage =
    typeof window !== 'undefined' &&
    /\/(login|reset-password)$/.test(window.location.pathname);
  try {
    if (!onAuthPage) {
      localStorage.setItem(
        'pendingDeepLink',
        window.location.pathname + window.location.search
      );
    }
    localStorage.setItem('sessionExpired', '1');
    // Clear the same keys the sidebar Logout removes so the next user
    // doesn't inherit a stale/invalid session.
    localStorage.removeItem('user');
    localStorage.removeItem('activeMenu');
    localStorage.removeItem('notificationsLastSeen');
    // Server-data caches must not survive into the next session on a
    // shared workstation (mirrors the sidebar Logout).
    sessionStorage.clear();
  } catch {
    /* ignore storage errors */
  }
  if (!onAuthPage) {
    window.location.href = '/login';
  }
}
